"use client";

import { BASE_URL } from "@/constants";
import { useRouter } from "next/navigation";
import { Button } from "../ui/button";

import { cn } from "@/lib/utils";
import GoogleIcon from "@/assets/icons/googleIcon";

const GoogleSignInButton = ({ className = "" }) => {
  const router = useRouter();
  const handleGoogle = () => {
    router.push(
      `${BASE_URL}/auth/google?redirectUrl=${encodeURIComponent(window.location.origin + "/login/callback")}`
    );
  };

  return (
    <Button
      type="button"
      className={cn(`bg-white hover:bg-slate-50 text-black`, className)}
      onClick={handleGoogle}
    >
      <GoogleIcon /> Login Google
    </Button>
  );
};

export default GoogleSignInButton;
